<div class="empty-page">
    <span class="not-found">404</span>
    <ng-container *ngIf="noRegistrations">
        <h2 data-automation="not-found-title">{{ 'registration.list.none_found' | translate }}</h2>
    </ng-container>
    <ng-container *ngIf="noRegistrationSets">
        <h2 data-automation="not-found-title">{{ 'registration.list.none_regSet_found' | translate }}</h2>
    </ng-container>
</div>
